import React, { useEffect, useRef, useState } from "react";
import search from "../Images/search.png";
import backBtn from "../Images/back.png";
import profile from "../Images/profile.png";
import add from "../Images/add.png";
import "../css/consultations.css";
import { Link } from "react-router-dom";
import { formatVitalForExport } from './VitalFormatter';


function Consultations() {
  const searchInputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [associatedDoctors, setAssociatedDoctors] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");


  const handleSearchClick = () => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
      setIsFocused(true);
    }
  };

  const handleBlur = (e) => {
    if (e.relatedTarget && e.relatedTarget.closest(".allResults")) {
      return; 
    }
    setIsFocused(false);
  };

  const getImageUrl = (imageField) => {
    if (!imageField) return profile;
    
    if (imageField.startsWith('user_images/')) {
      return `${process.env.REACT_APP_BASE_URL}/media/${imageField}`;
    }
    
    if (imageField.startsWith('http')) {
      return imageField;
    }
    
    return `${process.env.REACT_APP_BASE_URL}${imageField}`;
  };

  const handleExport = async (patientId) => {
    console.log("Exporting PDF");
    const exportBtn = document.getElementById('exportBtnID');
    exportBtn.disabled = true;
    exportBtn.innerText = 'Downloading...';
  
    try {
      // Use the passed patientId in the API call
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/patient-detail-assessment-export/${patientId}/`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );
      
      let detailedAssessmentData = await response.json();
  
      if (detailedAssessmentData.vitals) {
        detailedAssessmentData.vitals = detailedAssessmentData.vitals.map(vital => 
          formatVitalForExport(vital)
        );
      }
  
      if (detailedAssessmentData.health_meal_plans && Array.isArray(detailedAssessmentData.health_meal_plans)) {
        detailedAssessmentData.health_meal_plans = detailedAssessmentData.health_meal_plans.map(meal_plan => ({
          ...meal_plan,
          dish_name: typeof meal_plan.dish_name === 'object' ? meal_plan.dish_name.name : meal_plan.dish_name
        }));
      }
  
      const pdfResponse = await fetch(
        'https://anasdew.pythonanywhere.com/export-immuniso-pdf',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            export_type: 'detailed_assessment',
            data: detailedAssessmentData
          })
        }
      );
  
      if (pdfResponse.ok) {
        const pdfBlob = await pdfResponse.blob();
        const url = window.URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'detailed-assessment.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        exportBtn.disabled = false;
        setTimeout(() => exportBtn.innerText = 'Export Assessment', 2000);
      }
    } catch (error) {
      console.error("Export failed:", error);
      exportBtn.disabled = false;
      exportBtn.innerText = 'Failed';
      setTimeout(() => exportBtn.innerText = 'Export Assessment', 2000);
    }
  };

  

  const [allDoctors, setAllDoctors] = useState([]);
  const [patients, setPatients] = useState([]);
  const [doctor, setDoctor] = useState("");
  const [speciality, setSpeciality] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [specialities, setSpecialities] = useState([]);

  const [searchPat, setSearchPat] = useState([]);

  const fetchData2 = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/patients-user/`
      );
      const json = await response.json();

      if (response.ok) {
        setPatients(json);
        setSearchPat([
          ...(json.patients_with_doctor || []),
          ...(json.patients_without_doctor || []),
        ]);
      }
    } catch (error) {
      console.error("Error fetching patients:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/doctor-user/`
        );
        const json = await response.json();
        if (response.ok) {
          setAllDoctors(json);
          setAssociatedDoctors(json);
        }
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };

    

    const fetchData3 = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/specialities-options/`
        );
        const json = await response.json();
        if (response.ok) {
          setSpecialities(json);
        }
      } catch (error) {
        console.error("Error fetching specialities:", error);
      }
    };

    fetchData();
    fetchData2();
    fetchData3();
  }, []);

  

useEffect(() => {
  if (searchTerm) {
    const lowercasedSearchTerm = searchTerm.toLowerCase();
    
    const filteredPatients = searchPat
      .filter((patient) =>
        patient?.full_name?.toLowerCase().startsWith(lowercasedSearchTerm) ||
        patient.id.toString().startsWith(lowercasedSearchTerm)
      )
      .map(patient => ({
        ...patient,
        type: 'patient',
        displayName: patient.full_name,
        displayImage: getImageUrl(patient.image)
      }));

    const filteredDoctors = allDoctors
      .filter((doctor) =>
        doctor?.username?.toLowerCase().startsWith(lowercasedSearchTerm)
      )
      .map(doctor => ({
        ...doctor,
        type: 'doctor',
        displayName: doctor.username,
        displayImage: getImageUrl(doctor.image)
      }));

    const combinedResults = [...filteredPatients, ...filteredDoctors].sort((a, b) => 
      a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase())
    );

    setFilteredResults(combinedResults);
  } else {
    setFilteredResults([]);
  }
}, [searchTerm, searchPat, allDoctors]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    if (searchTerm) {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      
      const filteredPatients = searchPat.filter(
        (patient) =>
          patient?.full_name?.toLowerCase().startsWith(lowercasedSearchTerm) ||
          patient.id.toString().startsWith(lowercasedSearchTerm)
      );

      const filteredDoctors = allDoctors.filter((doctor) =>
        doctor?.username?.toLowerCase().startsWith(lowercasedSearchTerm)
      );

      const combinedResults = [
        ...filteredPatients.map(patient => ({
          ...patient,
          type: 'patient'
        })),
        ...filteredDoctors.map(doctor => ({
          ...doctor,
          type: 'doctor'
        }))
      ];

      const sortedResults = combinedResults.sort((a, b) => {
        const nameA = (a.type === 'patient' ? a.full_name : a.username).toLowerCase();
        const nameB = (b.type === 'patient' ? b.full_name : b.username).toLowerCase();
        return nameA.localeCompare(nameB);
      });

      setFilteredResults(sortedResults);
    } else {
      setFilteredResults([]);
    }
  }, [searchTerm, searchPat, allDoctors]);

  const handleLinkDoctor = async (e, id) => {
    e.preventDefault();
    try {
      const formData = {
        doctor_id: doctor,
      };

      console.log(doctor);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/asian-doctor/${id}/`,
        {
          method: "POST",
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to link doctor.");
      }

      const json = await response.json();
      fetchData2();
      console.log(json);
    } catch (error) {
      console.error("Error linking doctor:", error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); 
    const month = String(date.getMonth() + 1).padStart(2, "0"); 
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  return (
    <div className="conMain">
      {isFocused && <div className="blur"></div>}
      <div className="sna">
        <div className="searchnRes">
          <div className="cdpNavbar" onClick={handleSearchClick}>
            <div className="cdpn">
              <div className="cdpSearch">
              <input
                  type="text"
                  placeholder="Search Patients & Doctors"
                  ref={searchInputRef}
                  onBlur={handleBlur}
                  onFocus={() => setIsFocused(true)}
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                <div className="sImg">
                  <img src={search} alt="search" />
                </div>
              </div>
            </div>
            <img src={profile} alt="profile" />
          </div>

          {isFocused && searchTerm && (
  <div
    className="allResults"
    tabIndex={-1}
    onMouseDown={(e) => e.preventDefault()}
  >
    <p>Search Results</p>
    {filteredResults.length > 0 ? (
      filteredResults.map((result, index) => (
        <Link
          to={`/dash2/${result.id}`}
          key={index}
          className="resultItem"
        >
          <div className="flex items-center gap-2">
          <img 
                    src={getImageUrl(result.image)}
                    alt={`${result.full_name || result.username}'s profile`}
                    className="w-8 h-8 rounded-full object-cover"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = profile;
                    }}
                  />
            <div>
              <p className="font-medium">
                {result.type === 'patient' ? result.full_name : result.username}
              </p>
              <p className="text-sm text-gray-500">
                {result.type === 'patient' ? 'Patient' : 'Doctor'}
              </p>
            </div>
          </div>
        </Link>
      ))
    ) : (
      <p className="p-3 text-gray-500">No results found</p>
    )}
  </div>
)}
        </div>

        <div className="cdpNewOn">
          <h1>New Onboards</h1>
          <div className="cdpno">
            {patients.patients_without_doctor?.map((nob, index) => (
              <form
                className="cdpProf"
                key={index}
                onSubmit={(e) => handleLinkDoctor(e, nob.id)}
              >
                <div className="pinkBox">
                  <div className="profImg">
                    <img src={profile} alt="profile" />
                    <div className="pDesc">
                      <p>{nob.full_name}</p>
                      <p>{nob.phone_number}</p>
                    </div>
                  </div>
                  <Link to={`/dash2/${nob?.id}`}>
                    <button type="button">View Profile</button>
                  </Link>
                </div>
                <div className="pinkLine pl"></div>
                <div className="pinkBox">
                  <p>First Consultation Call</p>
                  <Link to={`/dash2/${nob?.id}/detass`}>
                    <button type="button">Consultation Form</button>
                  </Link>
                </div>
                <div className="pinkLine pl2"></div>
                <LinkDoctor allDoctors={allDoctors} setDoctor={setDoctor} specialities={specialities} speciality={speciality} setSpeciality={setSpeciality} />
                <div className="pinkLine pl2"></div>
                <div className="saveBtn">
                  <button type="submit">Save</button>
                </div>
              </form>
            ))}
            {patients.patients_without_doctor?.length === 0 && (
              <p>No new patients</p>
            )}
          </div>
        </div>

        <div className="cdpNewOn allCon">
          <div className="cdpnTop">
            <div className="headFit">
              <h1>All Consultations</h1>
            </div>
          </div>
          {patients.patients_with_doctor?.map((pt, index) => (
            <div className="cdpno" key={index}>
              <div className="cdpProf">
                <div className="pinkBox">
                  <div className="profImg">
                  <img 
                    src={getImageUrl(pt.image)}
                    alt={`${pt.full_name}'s profile`}
                    className="w-12 h-12 rounded-full object-cover" />  
                    <div className="pDesc">
                      <p>{pt.full_name}</p>
                      <p>{pt.phone_number}</p>
                    </div>
                  </div>
                  <Link to={{ pathname: `/dash2/${pt.id}`, state: { pt } }}>
                  <button>View Dashboard</button>
                 </Link>
                </div>
                <div className="pinkBox">
                  <p>Focus Area</p>
                  <HealthGoal2 patientId={pt.id} />
                </div>
                <div className="pinkBox pb">
                  <p>Linked Doctor</p>
                  <Link to={"/docprof"} style={{ textDecoration: "none" }}>
                    <b className="pink">{pt.doctor?.username}</b>
                  </Link>
                </div>
                <div className="pinkBox">
  <p>Recent Consultation Report</p>
  <button
  style={{
    backgroundColor: '#f23d76',
    color: 'white',
    padding: '1px 20px',
    border: 'none',
    borderRadius: '28px',
    width: '177px',
    height: '33px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '15px',
    transition: 'background-color 0.3s',
    textAlign: 'center',
    filter: 'drop-shadow(0px 0px 2px #f23d76)'
  }}
  id="exportBtnID"
  onClick={() => handleExport(pt.id)}  // Pass the patient ID here
>
  Download
</button>
</div>
                <div className="upCon">
                  <p>Upcoming</p>
                  <p>{formatDate(pt.consultatuon_date)}</p>
                  <div className="conNumber">
                    {/* <p>10<sup>th</sup></p>
                    <p>Consultation</p> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Consultations;

const HealthGoal2 = (props) => {
  const [healthGoal2, setHealthGoal2] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/health-goal/${props.patientId}/`,
        );
        const json = await response.json();
        if (response.ok) {
          setHealthGoal2(json.helth_goal.name);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return <b> {healthGoal2 ? healthGoal2 : "NA"} </b>;
};

const LinkDoctor = (props) => {
  
  const {specialities, setDoctor, speciality, setSpeciality, allDoctors} = props
  const [associatedDoctors, setAssociatedDoctors] = useState(null);


  // api/doctors-by-speciality/12/
  // fetching doctors based on speciality
  const fetchAssociatedDoctors = async (speciality) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/doctors-by-speciality/${speciality}/`,
      );
      const json = await response.json();
      if (response.ok) {
        setAssociatedDoctors(json);
        console.log("associatedDoctors", json);
      }
    } catch (error) {
      console.error("Error fetching specialities:", error);
    }
  };

  useEffect(() => {
    setAssociatedDoctors(allDoctors)
  }, []);


  return (
    <div className="pinkBox pb">
      <p>Link Doctor</p>
      <select
        onChange={(e) => {
          let value = e.target.value.split("-");
          setSpeciality(value[0]);
          fetchAssociatedDoctors(value[1]);
        }}
      >
        <option value="">Select Speciality</option>
        {specialities.map((sp, index) => (
          <option value={sp.name + "-" + sp.id} key={index}>
            {sp.name}
          </option>
        ))}
      </select>
      <select onChange={(e) => setDoctor(e.target.value)}>
        <option value="">Select Doctor</option>
        {associatedDoctors?.map((dt, index) => (
          <option value={dt.id} key={index}>
            {dt.username}
          </option>
        ))}
      </select>
    </div>
  )
}

// const NewOnboard = (props) => {
//   return (
//     <div className="cdpno">
//       {patients.patients_without_doctor?.map((nob, index) => (
//         <form
//           className="cdpProf"
//           key={index}
//           onSubmit={(e) => handleLinkDoctor(e, nob.id)}
//         >
//           <div className="pinkBox">
//             <div className="profImg">
//               <img src={profile} alt="profile" />
//               <div className="pDesc">
//                 <p>{nob.full_name}</p>
//                 <p>{nob.phone_number}</p>
//               </div>
//             </div>
//             <Link to={`/dash2/${nob?.id}`}>
//               <button type="button">View Profile</button>
//             </Link>
//           </div>
//           <div className="pinkLine pl"></div>
//           <div className="pinkBox">
//             <p>First Consultation Call</p>
//             <Link to={`/dash2/${nob?.id}/detass`}>
//               <button type="button">Consultation Form</button>
//             </Link>
//           </div>
//           <div className="pinkLine pl2"></div>
//           <div className="pinkBox pb">
//             <p>Link Doctor</p>
//             <select
//               onChange={(e) => {
//                 let value = e.target.value.split("-");
//                 setSpeciality(value[0]);
//                 fetchAssociatedDoctors(value[1]);
//               }}
//             >
//               <option value="">Select Speciality</option>
//               {specialities.map((sp, index) => (
//                 <option value={sp.name + "-" + sp.id} key={index}>
//                   {sp.name}
//                 </option>
//               ))}
//             </select>
//             <select onChange={(e) => setDoctor(e.target.value)}>
//               <option value="">Select Doctor</option>
//               {associatedDoctors?.map((dt, index) => (
//                 <option value={dt.id} key={index}>
//                   {dt.username}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div className="pinkLine pl2"></div>
//           <div className="saveBtn">
//             <button type="submit">Save</button>
//           </div>
//         </form>
//       ))}
//       {patients.patients_without_doctor?.length === 0 && <p>No new patients</p>}
//     </div>
//   );
// };
